import React, { useState } from "react";
import { FaShoppingCart, FaVideo, FaWifi, FaUser } from "react-icons/fa"; // Added FaUser icon
import { Link, useNavigate } from "react-router-dom";
import CartDropdown from "../components/CartDropdown";
import AccountDropdown from "../components/AccountDropdown";
import "../styles/HomeNavbar.css";

const HomeNavbar = ({
  cart,
  setCart,
  user,
  isLoggedIn,
  onLoginSuccess,
  onRemoveItem,
  guestCartId,
  setSelectedCategories,
  onUpdateQuantity,
  resetSelectedCategory,
}) => {
  const [isCartDropdownOpen, setIsCartDropdownOpen] = useState(false);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Toggle cart dropdown
  const toggleCartDropdown = () => {
    setIsCartDropdownOpen((prev) => !prev);
    setIsAccountDropdownOpen(false);
  };

  // Toggle account dropdown
  const toggleAccountDropdown = () => {
    setIsAccountDropdownOpen((prev) => !prev);
    setIsCartDropdownOpen(false);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("guestCartId");

      onLoginSuccess(null);
      setIsAccountDropdownOpen(false);
      window.location.href = `/home?logout=${Date.now()}`;
    } catch (error) {
      console.error("Logout error:", error);
      window.location.href = "/home";
    }
  };

  return (
    <nav className="home-navbar">
      <div className="navbar-bottom-border"></div>
      <div className="logo">
        <a href="/home" onClick={resetSelectedCategory}>
          <img src="/logo-net.png" alt="Website Logo" className="logo-image" />
        </a>
      </div>

      <ul className="nav-links">
        <li className="nav-item-with-icon">
          <a href="https://myzmaj.com/" className="plain-link">
            <div className="nav-icon-container">
              <FaVideo size={20} className="nav-icon" />
            </div>
            <span>Video nadzor</span>
          </a>
        </li>
        <li className="nav-item-with-icon">
          <a href="https://myzmaj.rs/" className="plain-link">
            <div className="nav-icon-container">
              <FaWifi size={20} className="nav-icon" />
            </div>
            <span>Internet</span>
          </a>
        </li>
        <li className="nav-item-with-icon cart-item desktop-only">
          <div className="nav-icon-container cart-icon-wrapper" onClick={toggleCartDropdown}>
            <FaShoppingCart size={20} className="nav-icon" />
            {cart.length > 0 && <span className="cart-count">{cart.length}</span>}
          </div>
          <span>Korpa</span>
          {isCartDropdownOpen && (
            <div className="cart-dropdown-container">
              <CartDropdown
                cartItems={cart}
                onRemoveItem={onRemoveItem}
                onUpdateQuantity={onUpdateQuantity}
                isLoggedIn={isLoggedIn}
                user={user}
              />
            </div>
          )}
        </li>

        <li className="nav-item-with-icon account-item desktop-only">
          {isLoggedIn ? (
            <>
              <div className="nav-icon-container" onClick={toggleAccountDropdown}>
                <FaUser size={20} className="nav-icon" />
              </div>
              <span>Nalog</span>
              <div className="account-dropdown-container">
                {isAccountDropdownOpen && (
                  <AccountDropdown handleLogout={handleLogout} user={user} />
                )}
              </div>
            </>
          ) : (
            <div className="auth-links desktop-only">
              <Link to="/login">Uloguj se</Link>
              <Link to="/register">Registruj se</Link>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default HomeNavbar;